import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import {
  ContentOct2020,
  DescriptionOct2020,
  PrivacyWrapper,
} from '../../v2/components/privacy';
import { PRIVACY_OCT_2020_LINKS_LIST } from '../../v2/constants';
import type { ISiteData } from '../../v2/interfaces/ISiteData';

const PrivacyOct2020: React.FC = () => {
  const {
    site: {
      siteMetadata: { contact },
    },
  } = useStaticQuery<ISiteData>(graphql`
    query GetPrivacyOctContactEmail {
      site {
        siteMetadata {
          contact {
            email
          }
        }
      }
    }
  `);
  return (
    <PrivacyWrapper
      revisedDate="Last Revised: October 12, 2020"
      content={<ContentOct2020 hoverEmail={contact.email} />}
      description={<DescriptionOct2020 />}
      tableOfContent={PRIVACY_OCT_2020_LINKS_LIST}
    />
  );
};

export default PrivacyOct2020;
